import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { Avatar } from "@/components/Avatar";

// Opt-in "near you now" — friends who are free and/or recently checked in on campus.
export default function NearYouRow() {
  const navigate = useNavigate();
  const [list, setList] = useState(null);

  useEffect(() => {
    api.get("/presence/friends").then((r) => setList(r.data.near_you || [])).catch(() => setList([]));
  }, []);

  if (!list || list.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }}
      data-testid="near-you-row"
      className="mb-4 bg-white border border-border rounded-xl p-4"
    >
      <div className="flex items-center gap-1.5 mono text-[11px] tracking-[0.2em] uppercase text-[#166534] mb-3">
        <span className="w-2 h-2 rounded-full bg-[#16A34A] animate-pulse" /> Near you now
      </div>
      <div className="flex gap-3 overflow-x-auto hide-scrollbar">
        {list.map((f) => (
          <button
            key={f.user_id}
            data-testid={`near-you-${f.user_id}`}
            onClick={() => navigate("/friends")}
            className="shrink-0 w-24 text-center group"
          >
            <div className="relative mx-auto w-14 h-14">
              <Avatar src={f.picture} name={f.name} size={56} className="ring-2 ring-[#16A34A]/40 group-hover:ring-[#16A34A] transition-all" />
              {f.free_now && <span className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-[#16A34A] ring-2 ring-white" />}
            </div>
            <div className="mt-1.5 text-xs font-semibold truncate">{(f.name || "").split(" ")[0]}</div>
            <div className="text-[11px] text-muted-foreground truncate flex items-center justify-center gap-0.5">
              {f.place ? <><MapPin size={10} strokeWidth={2} />{f.place}</> : "free now"}
            </div>
          </button>
        ))}
      </div>
    </motion.div>
  );
}
